/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.payroll.paytypes.leave
 * @name TimePayrollLeaveStaffEditorCtrl
 */
angular.module('mercury.modules.time.payroll.paytypes.allowance')
.controller('TimePayrollLeaveStaffEditorCtrl', ["$filter", "$scope", "TimePayrollLeave", "userinfo", "dialog", function($filter, $scope, TimePayrollLeave, userinfo, dialog) {
  $scope.quantityTypes = [
    {id: 0, description: 'Do not track'},
    {id: 1, description: 'Holidays Act'},
    {id: 2, description: 'Percent of Gross'}
  ];

  $scope.loading.then(function() {
    angular.forEach($scope.staff.paytypes, function(paytype) {
      paytype.values = JSON.parse(paytype.values);

      // Add defaults for any missing values
      if (!paytype.values.accumulatedLeave) {
        paytype.values.accumulatedLeave = 0;
      }
      if (!paytype.values.method) {
        paytype.values.method = paytype.paytype.defaultQuantity;
      }
      if (!paytype.values.entitlement) {
        paytype.values.entitlement = paytype.paytype.defaultRate;
      }
      if (!paytype.values.daysWorkedPerWeek) {
        paytype.values.daysWorkedPerWeek = 5;
      }

    });

    if (userinfo.companyHasPermission('Payroll,Salary')) {
      TimePayrollLeave.getAll()
      .then(function(result) {
        $scope.paytypes = result;

        // Add any default paytypes to this staff member
        angular.forEach($scope.paytypes, function(paytype) {
          if (paytype.autoAdd == 2) {
            var existing = $filter('filter')($scope.staff.paytypes, {paytypeId: paytype.id});

            if (!existing || existing.length === 0) {
              $scope.staff.paytypes.push({
                staffMemberId: $scope.staff.id,
                paytypeId: paytype.id,
                paytypeName: paytype.name,
                paytypeDefaultRate: paytype.defaultRate,
                paytypeDefaultQuantity: paytype.defaultQuantity,
                values: {
                  accumulatedLeave: 0,
                  method: paytype.defaultQuantity,
                  entitlement: paytype.defaultRate,
                  daysWorkedPerWeek: 5
                }
              });
            }
          }
        });

      });
    }
  });

  $scope.addAllowanceOptions = function() {
    var typeOptions = [];

    if (!$scope.staff) {
      return typeOptions;
    }

    angular.forEach($scope.paytypes, function(paytype) {
      if (paytype.autoAdd == 3) {
        var existing = $filter('filter')($scope.staff.defaultPaytypes, {paytypeId: paytype.id});

        if (!existing || existing.length === 0) {
          typeOptions.push(paytype);
        }
      }
    });
    return typeOptions;
  };

  $scope.addDefaultLeave = function(selectedAllowance) {
    $scope.staff.paytypeValues.push({
      paytypeName: selectedAllowance.name,
      paytypeId: selectedAllowance.id,
      paytypeDefaultQuantity: selectedAllowance.defaultQuantity,
      paytypeDefaultRate: selectedAllowance.defaultRate
    });
  };

  $scope.removeDefaultAllowance = function(index) {
    $scope.staff.paytypes.splice(index, 1);
  };

  $scope.changeMethod = function(staffPaytype, oldMethod) {
    //Set the entitlements to the default values for the new method.
    if (staffPaytype.values.method === 0) {
      staffPaytype.values.entitlement = null;
    } else if (staffPaytype.values.method === 1) {
      staffPaytype.values.entitlement = 4;
    } else {
      staffPaytype.values.entitlement = 8;
    }

    var newMethod = (staffPaytype.values.method !== null) ? staffPaytype.values.method :
      staffPaytype.paytype.defaultQuantity;
    oldMethod = (oldMethod !== null) ? oldMethod : staffPaytype.paytype.defaultQuantity;

    //If the calculation method for this staff members holiday pay has changed.
    if (newMethod != oldMethod) {
      //Get the staff year average hours per day and hourly rate.
      TimePayrollLeave.getAveragePay($scope.staff.id, moment())
        .then(function(averagePayPerDayResponse) {
          var averagePayPerDay = averagePayPerDayResponse.data;
          var newBalance = 0;
          var newBalanceLabel;

          // First, convert their existing accumulated leave to a dollar amount, if it is not already
          var oldBalance = staffPaytype.values.accumulatedLeave;
          if (oldMethod === 1) {
            oldBalance = oldBalance * averagePayPerDay;
          }

          // Then convert in into units appropriate to the new calculation method
          if (staffPaytype.values.method === 1) {
            newBalance = averagePayPerDay === 0 ? 0 : oldBalance / averagePayPerDay;
            newBalanceLabel = newBalance.toFixed(2) + ' days';
          } else {
            newBalance = oldBalance;
            newBalanceLabel = '$' + newBalance.toFixed(2);
          }

          var message = 'The new holiday pay balance for this staff member will be ' + newBalanceLabel + '. Calculated' +
          ' by ';

          if (oldMethod === 1) {
            message += ' multiplying the current balance of ' + parseFloat(staffPaytype.values.accumulatedLeave).toFixed(2) + ' days';
          } else {

            message += ' dividing the current balance of $' + parseFloat(staffPaytype.values.accumulatedLeave).toFixed(2);
          }

          message += ' by the average daily cost of $' + averagePayPerDay.toFixed(0);

          staffPaytype.values.accumulatedLeave = newBalance;

          // only show the dialog if transferring an existing balance between days and dollars
          if (newBalance && !((oldMethod === 0 && newMethod === 2) || (oldMethod === 2 && newMethod === 0))) {
            dialog.alert(message);
          }
        }, function() {

        }
      );
    }
  };
}]);
